import {combineReducers} from 'redux';
import * as types from '../actions/types';
import MainReducer from './mainReducer';
import ItemsReducer from './itemsReducer';

const appReducer = combineReducers({
    MainReducer,
    ItemsReducer
});


export const rootReducer = (state, action) => {

    if (action.type === types.LOG_OUT) {
        let new_state = {};
        state &&  Object.keys(state).forEach((reducer) => {

            if (state[reducer].isSecured) {
                new_state[reducer] = undefined
            }
            else {
                new_state[reducer] = state[reducer]
            }

        });
        if (new_state && Object.keys(new_state).length === Object.keys(state).length) {
            return appReducer(new_state, action)
        }

    }
    else {
        return appReducer(state, action)
    }


};
